import { render, staticRenderFns } from "./FormID.vue?vue&type=template&id=d823bf1e&"
import script from "./FormID.vue?vue&type=script&lang=js&"
export * from "./FormID.vue?vue&type=script&lang=js&"
import style0 from "./FormID.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports